// import React, { useContext } from "react";
// import { Redirect } from "react-router-dom";
// import Authmiddleware from "./route";
// import { MasterContext } from "./MasterContext"
//
//
// // eslint-disable-next-line react/prop-types
// const MasterOpenMiddleware = ({ component: Component, layout: Layout, ...rest }) => {
//   const context = useContext(MasterContext);
//
//   // Sécurité si le Provider n’est pas encore prêt
//   if (!context) {
//     console.error("❌ MasterContext non trouvé");
//     return <Redirect to="/Redirection" />;
//   }
//
//   const { etat, loading } = context;
//
//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: 50 }}>
//         Chargement...
//       </div>
//     );
//   }
//
//   // ❌ Master fermé
//   if (etat !== 0) {
//     return <Redirect to="/Redirection" />;
//   }
//
//   // ✅ Master ouvert
//   return (
//     <Authmiddleware
//       {...rest}
//       component={Component}
//       layout={Layout}
//       isAuthProtected={false}
//     />
//   );
// };
//
// export default MasterOpenMiddleware;



import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import Authmiddleware from "./route";
import { MasterContext } from "./MasterContext";

// eslint-disable-next-line react/prop-types
const MasterOpenMiddleware = ({ component: Component, layout: Layout, ...rest }) => {
  const { etat, loading } = useContext(MasterContext);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: 50 }}>Chargement...</div>;
  }

  // ❌ Master fermé
  if (etat !== 0) {
    return <Redirect to="/Redirection" />;
  }

  // ✅ Master ouvert
  return (
    <Authmiddleware
      {...rest}
      component={Component}
      layout={Layout}
      isAuthProtected={false}
    />
  );
};

export default MasterOpenMiddleware;
